"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchResult = void 0;
const fetch_hook_1 = require("./fetch-hook");
function useFetchResult(url, params) {
    const [result, loading, reset, setLoading] = fetch_hook_1.useFetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
    });
    return { items: [], count: 0, ...result, loading, setLoading, reset };
}
exports.useFetchResult = useFetchResult;
//# sourceMappingURL=fetch-result-hook.js.map